import styled from "styled-components";

export const AchievementPreviewStyled = styled.div<{ imageSize: number; }>`
    flex-basis: calc((100% - 32px) / 3);

    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin: 8px 0;
    overflow: hidden;
    cursor: pointer;

    img {
        width: ${({ imageSize }) => imageSize + 'px'};
        height: ${({ imageSize }) => imageSize + 'px'};
        margin-bottom: 4px;

        @media (max-width: 320px) {
            width: 100%;
            height: 100%;
            max-width: ${({ imageSize }) => imageSize + 'px'};
            max-height: ${({ imageSize }) => imageSize + 'px'};
        }
    }
`;

export const AchievementPreviewTitleStyled = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: var(--color-label-primary);

    overflow: hidden;
    text-overflow: ellipsis;
`;

export const AchievementPreviewDescrStyled = styled.div`
    font-size: 10px;
    font-weight: 400;
    color: var(--color-label-secondary);
`;

export const AchievementPreviewTimesStyled = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: var(--color-positive);
    margin-bottom: 8px;
`;

export const AchievementPreviewCompletedDateStyled = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: var(--color-label-secondary);
    margin-top: 18px;
`;

export const AchievementPreviewFlashScreenStyled = styled.div`
    img {
        width: 220px;
        height: 220px;

        @media (max-width: 320px) {
            width: 100%;
            height: 100%;
            max-width: 220px;
            max-height: 220px;
        }
    }
`;

export const AchievementPreviewProgressStyled = styled.div<{ percent: number }>`
    margin: 8px 8px 0;
    border-radius: 2px;
    height: 4px;
    background: var(--color-fill-secondary);
    position: relative;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
        border-radius: 2px;
        width: ${({ percent }) => percent}%;
        background: var(--color-label-accent);
    }
`;
